import React, { useEffect, useMemo, useState } from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { people } from "../../config/imagesLink";
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";

const ChatForwardModal = ({
  show,
  onClose,
  messageList,
  currentUserId,
  message,
  onForward,
  isForwarding,
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!show) {
      setSearch("");
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [show]);

  const contacts = useMemo(() => {
    const list = Array.isArray(messageList) ? messageList : [];
    const query = search.trim().toLowerCase();

    return list
      .filter(
        (item) =>
          item?.chatInfo?.toUserUid &&
          String(item.chatInfo.toUserUid) !== String(currentUserId)
      )
      .filter((item) => {
        if (!query) return true;
        const name = item.chatInfo?.toUserFullName || "";
        return name.toLowerCase().includes(query);
      });
  }, [messageList, currentUserId, search]);

  if (!show) return null;

  const preview = message?.msg?.trim() || "";

  return (
    <Portal layer="modal">
      <div className="chat-forward-modal-backdrop" onClick={onClose}>
      <div
        className="chat-forward-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={t("Notifications.Forward")}
      >
        <div className="chat-forward-modal-header d-flex justify-content-between align-items-center">
          <h6 className="mb-0 f-14 f-600">{t("Notifications.Forward")}</h6>
          <CloseSharpIcon
            className="material-symbols-sharp pointer"
            onClick={onClose}
          />
        </div>

        {preview ? (
          <div className="chat-forward-preview f-12">{preview}</div>
        ) : null}

        <div className="chat-forward-search px-3 pb-2 pt-2">
          <input
            type="text"
            className="form-control f-12"
            placeholder={t("People.Search user")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="chat-forward-list">
          {contacts.length === 0 ? (
            <p className="text-center text-muted f-12 py-3 mb-0">
              {t("Notifications.No results")}
            </p>
          ) : (
            contacts.map((item) => {
              const avatar =
                !item.chatInfo?.toUserImage || item.chatInfo.toUserImage === ""
                  ? people.DefaultProfile
                  : item.chatInfo.toUserImage;

              return (
                <button
                  key={item.chatInfo.toUserUid}
                  type="button"
                  className="chat-forward-contact"
                  disabled={isForwarding}
                  onClick={() => onForward(item)}
                >
                  <img
                    src={avatar}
                    alt={item.chatInfo?.toUserFullName || ""}
                    width={40}
                    height={40}
                    onError={(e) => {
                      e.target.src = people.DefaultProfile;
                    }}
                  />
                  <span className="chat-forward-contact-name f-12 f-600">
                    {item.chatInfo?.toUserFullName}
                  </span>
                </button>
              );
            })
          )}
        </div>
      </div>
    </div>
    </Portal>
  );
};

export default ChatForwardModal;
